/**
 * Checkbox Component - Constants
 * ==============================
 */

import { getIcon } from '../../icons';

export type CheckboxSize = 'sm' | 'md';

export interface CheckboxSizeStyles {
  box: string;
  label: string;
}

export interface CheckboxDefaultValues {
  size: CheckboxSize;
}

export const SIZES: Record<CheckboxSize, CheckboxSizeStyles> = {
  sm: { box: 'ec-w-4 ec-h-4', label: 'ec-text-sm' },
  md: { box: 'ec-w-5 ec-h-5', label: 'ec-text-base' }
};

export const BASE_CLASSES = {
  wrapper: 'ec-inline-flex ec-items-center ec-gap-3 ec-cursor-pointer ec-select-none',
  wrapperDisabled: 'ec-cursor-not-allowed ec-opacity-60',
  input: 'ec-sr-only',
  // La caja visual la aporta el arte del registro (borde + relleno propios);
  // este span solo dimensiona y aplica color/foco.
  box: 'ec-inline-flex ec-items-center ec-justify-center ec-rounded ec-transition-colors ec-flex-shrink-0',
  boxUnchecked: 'ec-text-color-border',
  boxChecked: 'ec-text-color-primary',
  boxFocused: 'ec-ring-2 ec-ring-color-primary ec-ring-offset-1',
  label: 'ec-text-color-text'
};

/** Arte de la librería de íconos (`src/icons`) — reemplaza el box+check dibujado a mano. */
export const UNCHECK_ICON: string = getIcon('checkbox-uncheck') || '';
export const CHECK_ICON: string = getIcon('checkbox-checke') || '';

export const DEFAULTS: CheckboxDefaultValues = { size: 'md' };
